import React, { ReactNode, Suspense } from 'react'
import { Redirect, Route, RouteProps, Switch, useHistory } from 'react-router'
import { observer } from 'mobx-react'
import { routerStore } from './RouterStore'
import { useLocationChange } from '../../common/hooks/common/useLocationChange'

/**
 * 路由配置，兼容官方 RouteProps，在 meta 字段中添加额外的信息
 */
export type RouteConfig = RouteProps & {
    meta?: {
        name?: string
        //标题
        title?: string
    }
}

type PropsType = {
    routes: RouteConfig[]
    home?: string
    noMatch?: ReactNode
    fallback?: NonNullable<ReactNode>
}

const RenderRouteList: React.FC<PropsType> = observer(function(props) {
    //初始化 history 到全局变量中，便于在所有地方引用
    routerStore.history = useHistory()
    useLocationChange((val, old) => {
        // console.log('useLocationChange: ', val, old)
    })

    return (
        <div>
            <Suspense fallback={props.fallback || ''}>
                <Switch>
                    {props.routes.map((route, i) => {
                        const { component, ...other} = route
                        return <Route key={i} {...other} render={props => {
                            document.title = route.meta?.title || document.title;
                            return <route.component {...props} />
                        }} />
                    })}
                    {/*注：Redirect 必须在 route 列表渲染之后，因为是 / 所以必须启用严格模式，避免匹配所有页面*/}
                    {props.home && <Redirect exact path="/" to={props.home} />}
                    {props.noMatch && <Route path="*">{props.noMatch}</Route>}
                </Switch>
            </Suspense>
        </div>
    )
})
export default RenderRouteList
